import React, { useRef } from 'react';
import { MdOutlineInventory2 } from 'react-icons/md';
import './index.css';

export default function FileUploadDrag({ onInputChange, onDrop, prompt, currFileSize, sizeLimit, style={}}) {
  const fileInputRef = useRef(null);

  const handleClickUpload = () => {
    fileInputRef.current.click();
  };
  
  return (
    <div
      className="drop-area"
      onClick={handleClickUpload}
      onDrop={onDrop}
      onDragOver={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      style={style}
    >
      <div className="upload-drag-icon">
        <MdOutlineInventory2 style={{ fontSize: "40px" }} />
      </div>
      <div className="upload-text">
        Click or drag files to this area to upload
      </div>
      <div className="upload-hint">
        {prompt} <br />
        File size:{" "}
        <span
          style={{
            color:
              currFileSize > sizeLimit * 1024 * 1024 ? "var(--red)" : "",
          }}
        >
          {(currFileSize / 1024 / 1024).toFixed(1)}MB
        </span>
        /{sizeLimit >= 1024 ? `${sizeLimit / 1024}GB` : `${sizeLimit}MB`}
      </div>
      <input
        type="file"
        multiple
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={onInputChange}
      />
    </div>
  )
}
